













import {defineComponent, onMounted, PropType} from "@vue/composition-api"
import {useGetters, useMutations, useState} from "vuex-composition-helpers"

import {IWidgetConfig} from "../models/store-state"

import CloseButtonAtom from "@/shared/components/atoms/CloseButtonAtom.vue"
import HeroSliderComponent from "./HeroSlider/HeroSliderComponent.vue"
import IntroSliderComponent from "./IntroSlider/IntroSliderComponent.vue"
import MultipleSliderComponent from './MultipleSlider/MultipleSliderComponent.vue'
import SingleSliderComponent from './SingleSlider/SingleSliderComponent.vue'

export default defineComponent({
  name: "ContentSliderWidget",
  components: {
    CloseButtonAtom,
    HeroSliderComponent,
    IntroSliderComponent,
    MultipleSliderComponent,
    SingleSliderComponent
  },
  methods: {
    handleSwipe(direction: string) {
      this.$store.dispatch('swipe', {direction: direction})
    }
  },
  props: {
    config: {
      type: Object as PropType<IWidgetConfig>,
      required: true
    }
  },
  setup: (props) => {
    const {setConfig, setIsHidden, hideWidget, videoIsPlaying} = useMutations(['setConfig', 'setIsHidden', 'hideWidget', 'videoIsPlaying'])
    setConfig(props.config)
    setIsHidden()
    const {isHidden} = useState(['isHidden'])
    const {sliderComponent} = useGetters(['sliderComponent'])

    onMounted(() => {
      window.addEventListener('videoIsStopped', function () {
        videoIsPlaying(false)
      })

      window.addEventListener('videoIsPlaying', function () {
        videoIsPlaying(true)
      })
    })

    return {
      hideWidget,
      isHidden,
      sliderComponent
    }
  }
})
